import React, { useEffect } from "react";

import { useModalDataStore } from "../../store/modalData";

interface Props {}

const Modal: React.FC<Props> = () => {
    const ModalData2 = useModalDataStore<any>((s) => s.modalData2);
    const setModalData2 = useModalDataStore<any>((s) => s.setModalData2);

    let template;

    return (
        <>
            <div id={`${ModalData2?.position || "bottom"}-modal`} className={ModalData2?.toggle ? "" : "d-none"}>
                <div className="close-modal">
                    <span
                        onClick={() => {
                            setModalData2({});
                        }}
                    >
                        &times;
                    </span>
                </div>
                {template}
            </div>
            <div
                id="modal2-dark-bg"
                className={ModalData2?.toggle ? "" : "d-none"}
                onClick={() => {
                    setModalData2({});
                }}
            ></div>
        </>
    );
};

export default Modal;
